/* SchemaForm component */
import React, { useEffect, useRef, memo } from "react";
import { useNodes } from "components/util/helpers/providers/NodesProvider";
import { useCollections } from "components/util/helpers/providers/CollectionsProvider";
import $ from "jquery"
import View from "components/util/schema_form/SchemaForm.view";

const SchemaForm = memo(function SchemaFormComponent({
  parentRef,
  schema = [],
  parentId,
  initialValues,
  submitText = "Guardar",
  submitComponent,
  isPreview = false,
  isReadOnly = false,
  isCommentEnabled = false,
  showSideSteps = true,
  appId,
  actionId,
  flowId,
  nodeId,
  executionId,
  onChange = () => { },
  onSubmit
}) {
  const isDeveloper = sessionStorage.getItem("is_developer") == "true";
  const formRef = useRef(null);
  const componentRef = useRef(null);

  const { reqNodes, reqEdges } = useNodes({ checkContext: false });
  const { reqCollections } = useCollections({ checkContext: false });

  useEffect(() => {
    setTimeout(() => {
      // Focus the first input (non-hidden) on mount
      let inputs = $(`
        .schema-form input:not(.hidden-field):not([type=hidden]), 
        .schema-form textarea, 
        .schema-form .MuiInputBase-root:not(.not-autocomplete), 
        .schema-form .tiptap`)
        .filter(() => $(this).css("opacity") != 0);
      if (inputs.length > 0 && componentRef.current?.contains(inputs[0]))
        inputs[0].focus();
    }, 250)
  }, []);

  useEffect(() => {
    // Refresh available references when their providers are updated
    if (!isPreview) {
      reqNodes?.refetch?.();
      reqEdges?.refetch?.();
      reqCollections?.refetch?.();
    }
  }, []);

  useEffect(() => {
    // Update form values when initialValues prop changes
    if (formRef.current)
      formRef.current.setValues(initialValues ?? {});
    if (parentRef && parentRef.current)
      parentRef.current.setValues(initialValues ?? {});
  }, [initialValues]);

  return (
    <View
      formRef={parentRef || formRef}
      componentRef={componentRef}
      schema={schema}
      appId={appId}
      actionId={actionId}
      flowId={flowId}
      nodeId={nodeId}
      parentId={parentId}
      executionId={executionId}
      initialValues={initialValues}
      showSideSteps={showSideSteps}
      submitText={submitText}
      submitComponent={submitComponent}
      isPreview={isPreview}
      isDeveloper={isDeveloper}
      isReadOnly={isReadOnly}
      isCommentEnabled={isCommentEnabled}
      onChange={onChange}
      onSubmit={onSubmit}
    />
  );
});

export default SchemaForm;
